export default "__VITE_ASSET__DlCwi3sF__"